import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { signedInUserAtom } from "../state/atoms";
import { getDbUser } from "../services/firebase";

// This page is deprecated - redirect users to onboarding instead
const WaitForOnboarding: FC = () => {
  const navigate = useNavigate();
  const signedInUser = useRecoilValue(signedInUserAtom);

  useEffect(() => {
    // Immediately redirect to onboarding - no waiting
    // Users should complete Outreach auth to create/assign their org
    if (signedInUser) {
      // Always redirect to onboarding - they need to complete Outreach auth
      navigate("/app/continue-onboarding", { replace: true });
    } else {
      navigate("/auth/login", { replace: true });
    }
  }, [navigate, signedInUser]);

  return null;
};

export default WaitForOnboarding;
